<template>
          <div class="flex gap-3 justify-between items-center p-2 rounded-md mb-[15px]">
                  <span :class="` ${fontSize ? fontSize : 'text-[14px]'} ml-3   font-semibold`">{{ title }}</span>
                  <label class=" relative inline-flex items-center cursor-pointer w-fit   ">
                    <input type="checkbox" v-model="togglerVal" class="sr-only peer" @change="changeVal">
                    <div
                      class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-500">
                    </div>
                  </label>
                </div>
</template>

<script>

export default {
  props:['val' , 'title' , 'name' , 'fontSize'],
    data() {
    return {

      togglerVal:false,

   
    };
  },

  methods:{
     
    changeVal(){
      this.$emit('toggleTogglar' , this.$props.name ,  this.togglerVal )
    }
  },

  mounted(){
    this.$props.val && ( this.togglerVal = this.$props.val);
  },

  watch:{
    // togglerVal(val){
    //   this.$emit('toggleTogglar' , this.$props.name ,  val )
    // },
    val(newVal, oldVal) {
      this.togglerVal = newVal
    },

  }
}
</script>

<style>

</style>